import { inject, provide, type InjectionKey } from 'vue'

export interface Injection<T> {
  key: InjectionKey<T>
  provide: (value: T) => T
  use: () => T
}

export function defineInjection<T>(description: string): Injection<T> {
  const key: InjectionKey<T> = Symbol(description)

  return {
    key,
    provide: (value: T): T => {
      provide(key, value)
      return value
    },
    use: (): T => {
      const value = inject(key)
      if (value === undefined) {
        throw new Error(
          `[defineInjection] Провайдер для "${description}" не найден. Вызовите .provide() в компоненте-родителе.`
        )
      }
      return value
    },
  }
}
